import { SpecificSyncStatusResponse } from 'app/modules/settings/infrastructure/dto/response/SpecificSyncStatusResponse';
import { SpecificSyncStatus } from 'app/modules/settings/domain/entity/SpecificSyncStatus';
import { SyncContextType } from 'app/modules/settings/domain/valueObject/SyncContextType';
import { SyncStatus } from 'app/modules/settings/domain/valueObject/SyncStatus';

export class SpecificSyncStatusMapper {

    public static toDomain(response: SpecificSyncStatusResponse): SpecificSyncStatus {
        return new SpecificSyncStatus(
            response.id,
            new SyncContextType(response.context_type),
            response.context_id,
            response.name,
            new SyncStatus(response.status),
            response.started_at ? new Date(response.started_at) : null,
            response.finished_at ? new Date(response.finished_at) : null,
            response.pending_count,
        );
    }

    public static toDomainArray(responses: SpecificSyncStatusResponse[]): SpecificSyncStatus[] {
        return responses.map((response) => SpecificSyncStatusMapper.toDomain(response));
    }

}
